import React, { useEffect } from 'react'
import jwt_decode from 'jwt-decode'
import { useLocation, Navigate, useNavigate } from 'react-router-dom'
import { orderActivatedByMaxClouduc } from '../../../../../api/services/MaxCloudAPI'

export default function OrderActivatedByMaxCloudUc() {
  const location = useLocation()
  const navigate = useNavigate()
  const queryParams = new URLSearchParams(location.search)

  const ct = queryParams.get('ct')
  const oid = queryParams.get('oid')
  const companyId = queryParams.get('company_id')

  const token = localStorage.getItem('sd_cp.jwt:tkn')

  const isAuthenticated = (() => {
    if (!token) return false
    try {
      const decoded = jwt_decode(token)
      return !!decoded?.company_id && !!decoded?.company_level
    } catch {
      return false
    }
  })()

  useEffect(() => {
    localStorage.setItem('ProductCode', 'CVUC')
    if (ct && oid && companyId) {
      localStorage.setItem('ct', ct)
      localStorage.setItem('oid', oid)
      localStorage.setItem('OrderActivatedCompanyId', companyId)
    }

    if (ct && oid && isAuthenticated && companyId) {
      activateOrder()
    }
  }, [ct, oid, companyId])

  const activateOrder = async () => {
    try {
      const response = await orderActivatedByMaxClouduc({ ct, oid, companyId })
      const alreadyActivatedMsg = '<h1>Your order is already Activated.</h1>'

      const isAlreadyActivated =
        typeof response.data === 'string' &&
        response.data.includes(alreadyActivatedMsg)

      localStorage.setItem('isAlreadyActivatedByMaxCloudUc', isAlreadyActivated)
      localStorage.setItem('OrderActivatedByMaxCloudUc', true)
    } catch (error) {
      localStorage.setItem('OrderActivatedByMaxCloudUc', false)
    } finally {
      navigate('/', { replace: true })
    }
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return null
}
